import { useI18n } from "@/hooks/useI18n";
import { dictionary } from "@/lib/i18n";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cads-solutions/artifacts/fb4d6e1e_photo_5316519551212133005_y.jpg";

const handleAnchor = (id) => (event) => {
  event.preventDefault();
  const node = document.getElementById(id);
  if (node) node.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Footer = () => {
  const { lang } = useI18n();
  const links = dictionary.nav[lang];
  const f = dictionary.footer;
  const c = dictionary.contacts;
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-white border-t border-[#E2E8F0] pt-16 pb-8"
    >
      <div className="container mx-auto px-6 md:px-10 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={LOGO_URL}
              alt="CADS"
              className="h-24 md:h-28 w-auto object-contain"
            />
            <p className="mt-6 text-sm text-[#475569] leading-relaxed max-w-md">
              {f.tagline[lang]}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.25em] uppercase text-[#1857D6] font-bold">
              {f.nav_title[lang]}
            </h4>
            <ul className="mt-5 space-y-3">
              {links.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={handleAnchor(link.id)}
                    data-testid={`footer-link-${link.id}`}
                    className="text-sm text-[#475569] hover:text-[#0F2756] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] tracking-[0.25em] uppercase text-[#1857D6] font-bold">
              {f.contact_title[lang]}
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="text-[#475569]">
                {lang === "ru"
                  ? c.address_value_ru
                  : lang === "kz"
                    ? c.address_value_kz
                    : c.address_value_en}
              </li>
              <li>
                <a
                  href={`tel:${c.phone_value.replace(/\s+/g, "")}`}
                  data-testid="footer-phone"
                  className="text-[#0A1933] font-semibold hover:text-[#1857D6] transition-colors"
                >
                  {c.phone_value}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${c.email_value}`}
                  data-testid="footer-email"
                  className="text-[#0A1933] font-semibold hover:text-[#1857D6] transition-colors"
                >
                  {c.email_value}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#E2E8F0] flex flex-col sm:flex-row gap-3 sm:items-center justify-between text-xs text-[#475569]">
          <div>
            © {year}{" "}
            {lang === "ru"
              ? dictionary.meta.company_full_ru
              : lang === "kz"
                ? dictionary.meta.company_full_kz
                : dictionary.meta.company_full_en}
            . {f.rights[lang]}
          </div>
          <div className="tracking-[0.3em] uppercase text-[#94A3B8]">
            CADS · ALMATY · KZ
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
